import { faHandPointRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Slide } from 'react-reveal';
import { Link } from 'react-router-dom';
import PopularCourse from '../PopularCourse/PopularCourse';
import './HeroSlide.css'

const HeroSlide = () => {
    return (
        <section>
            <section className='p-5 kalachan' style={{ background: '#16171F' }}>
                <div className='container-fluid p-5'>
                    <div className="row gy-5" style={{ paddingTop: '50px' }}>
                        <div className="col-lg-7 col-md-12 col-sm-12 col-12">
                            <Slide right>
                                <div className="slide-title">
                                    <h1 className='text-light fw-bold lh-base'>টেন মিনিট স্কুলে হবে ৬ষ্ঠ থেকে ৯ম <br /> শ্রেণির বার্ষিক পরীক্ষার <br /> বিশেষ প্রস্তুতি</h1>
                                    <div className="slide-btn d-flex align-items-center justify-content-between flex-wrap mt-4 heroBtn">
                                        <Link to='/skills'>
                                            <button type="button" class="btn btn-danger fs-5 mt-2">জনপ্রিয় কোর্সসমূহ<FontAwesomeIcon icon={faHandPointRight} className='ms-1' /></button>
                                        </Link>
                                        <Link to='/class1to12'>
                                            <button type="button" class="btn btn-outline-light fs-5 mt-2">সব ক্লাস দেখুন <FontAwesomeIcon icon={faHandPointRight} className='ms-1' /></button>
                                        </Link>
                                    </div>
                                </div>
                            </Slide>
                        </div>
                        <div className="col-lg-5 col-md-12 col-sm-12 col-12">
                            <Slide left>
                                <div className="youtube">
                                    <img src="https://i.ibb.co/Cn1mRX6/heroslide.webp" alt="logo" className='img-fluid ms-2' />
                                </div>
                            </Slide>
                        </div>
                    </div>
                </div>
            </section>
            {/* ================Popular course====================== */}
            <div className="popular-course">
                <PopularCourse />
            </div>
        </section>
    );
};

export default HeroSlide;